import { EpicIcons } from "@constellation-academy/epic-ui";
import moment from "moment/moment";
import { useFragment } from "react-relay";
import { useNavigate } from "react-router-dom";
import { editMessageDispatchButton_MessageDispatchFragment$key } from "@relay/editMessageDispatchButton_MessageDispatchFragment.graphql";

import { MESSAGE_DISPATCH_FRAGMENT } from "./edit-message-dispatch-button.graphql";
import { buttonWrapperClass } from "./edit-message-dispatch-button.styles";
import { EditMessageDispatchButtonProps } from "./edit-message-dispatch-button.types";
import { Button, ButtonVariant } from "../../../components/button";
import { Paths } from "../../../routes/paths";

export const EditMessageDispatchButton = ({
	messageDispatchFragmentRef,
}: EditMessageDispatchButtonProps) => {
	const navigate = useNavigate();

	const messageDispatch = useFragment<editMessageDispatchButton_MessageDispatchFragment$key>(
		MESSAGE_DISPATCH_FRAGMENT,
		messageDispatchFragmentRef ?? null,
	);

	const handleOnEditClick = () => {
		navigate(Paths.messagesDispatches.withId(messageDispatch.id).edit.path);
	};

	const messageAlreadySent = moment(messageDispatch.dispatchedAt?.replace("[UTC]", "")).isBefore(
		moment(),
	);

	return (
		<div className={buttonWrapperClass}>
			<Button
				disabled={messageAlreadySent}
				icon={EpicIcons.PENCIL}
				variant={ButtonVariant.Strong}
				onClick={handleOnEditClick}
			/>
		</div>
	);
};
